import React, { useCallback, useEffect, useState } from 'react';
//import {
//    Navbar, NavbarBrand, Nav,
//   NavItem
//} from 'reactstrap';
import { AgGridReact } from 'ag-grid-react';
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { BsCircle, BsCheckCircle } from "react-icons/bs";
import { TiTick, TiTickOutline } from "react-icons/ti";
import { crPkgAct, hidePkgsAct, showLoader, showUpdProj, refreshApp } from '../redux/ctrl/ctrlActions';
import userLogo from '../../assets/svg/user.svg';
import Successfull from '../../assets/svg/Successfull.svg';
import Loader from '../loader';
import getDt, { fetchActiveUsers, fetchAppAccUsers, statusBar } from '../../utils';
import PermissionDates from './DatePicker';
import ButtonC from '../shared/ButtonC';
import './index.scss'
import { createPrjAsn, fetchPrjAsn, updatePrjAsn } from '../redux/prjasn/prjAsnActions';
import { CREATE_PRJASN } from '../redux/prjasn/prjAsnTypes';
import UpdateProject from '../createProject/updProj';
import SettingsMenu from '../settingsMenu/SettingsMenu';
import HOC from '../HOC/HOC';
import { sendMailStart } from '../redux/project/projActions';
import { fetchActivePGApps } from '../redux/app/appActions';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Container from '@mui/material/Container';
import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import DynamicBreadcrumbs from "../shared/DynamicBreadcrumbs";
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import { notiPL } from './emailNotification';
import { agGridTrans } from "../translation/i18n";
import { useTranslation } from 'react-i18next';
import config from '../../utils/config';
import COLORS from '../styles/COLORS';



const disb = false;

const Permissions = (props) => {
    const ctrlState = useSelector((state) => state.ctrl);
    const profileState = useSelector((state) => state.profile);
    const rowdata = useSelector(state => state.prjasn.projectsAsn);
    const userData = useSelector(state => state.prjasn.userData);
    const activeApps = useSelector(state => state.app.activeApps);
    const BtnC = useCallback(HOC(ButtonC, disb), []);
    const [gridApi, setGridApi] = useState(null);
    const { t, i18n } = useTranslation();
    // console.log("profileState",profileState)
    //console.log("rowdata",rowdata)
    //console.log("userData",userData)
    // const write = useSelector(state =>state.projectData);
    const [state, setState] = useState({
        input: '',
        projectData: [],
        UserList: [],
        selectedUserList: [],
        assignedUsers: '',
        hidePermissionGrid: true,
        hideCheckList: false,
        Ownerslist: [],
        checkedUsers: [],
        hideViewAllBtn: false,
        addpersonbtn: false,
        viewall: true,
        hideMessage: true,
        hideSearchedCheckList: true,
        isApplyDisabled: true
    })

    //const wrt_accs=state.projectData.map((data) => data.write_access)[0]
    //  console.log("state.selectedUserListddfdddd",state.selectedUserList)
    //  console.log("state.checkedUsers",state.checkedUsers)
    // useEffect(()=>{
    // },[wrt_accs])

    const dispatch = useDispatch();
    // const history = useHistory();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(showLoader(true));
        dispatch(fetchPrjAsn());
        dispatch(fetchActivePGApps());
        dispatch(showLoader(false));
    }, [dispatch]);

    useEffect(() => {
        return () => {
            dispatch({ type: CREATE_PRJASN, userData: [] });
            setState({ ...state, checkedUsers: [], Ownerslist: [], selectedUserList: [], input: "", UserList: [], projectData: [] })
        }
    }, []);

    const [writeAcc, setWriteAcc] = useState();

    const [grantPermission, setGrantPermission] = useState(false);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };


    const buildGrid = async (project) => {
        // const userList = state.UserList.length > 0 ? state.UserList : await fetchAppAccUsers();
        const userList = state.UserList.length > 0 ? state.UserList : await fetchActiveUsers();

        if (userList === 403) {
            dispatch(refreshApp(true))
        }
        let Ownernames = [];
        let Owner = ctrlState.data;
        let Write = project.find(o => o.write_access === "Y");
        let Read = project.find(o => o.read_access === "Y");

        Ownernames.push({ Role: t('OWNER'), Name: Owner.owner_name })

        if (Write !== undefined || Read !== undefined) {
            Ownernames.push({ Role: t('ASSOCIATES') + "(" + project.length + ")", Name: project[project.length - 1].first_name + ' ' + project[project.length - 1].last_name })
        }
        dispatch(showLoader(false))
        return { projectData: project, Ownerslist: Ownernames, UserList: userList }
    }

    useEffect(() => {
        const loadPermissions = async () => {
            // const project = rowdata.filter((item) => item.project_number === ctrlState.data.project_number);
            const project = rowdata.filter((item) => item.project_id === ctrlState.data.project_id);
            dispatch(showLoader(true));
            const returnData = await buildGrid(project);
            setState({ ...state, ...returnData })
        };
        loadPermissions();
    }, [rowdata, ctrlState.data]);

    useEffect(() => {
        let write_accs = rowdata.filter((item) => item.project_id === ctrlState.data?.project_id && profileState.email?.toLowerCase() === item.email_id?.toLowerCase())[0]?.write_access
        write_accs = ctrlState.data.created_by?.toLowerCase() === profileState.email?.toLowerCase() || write_accs == 'Y' ? true : false
        if (!write_accs) {
            write_accs = (profileState.capb.findIndex((o) => o.PWSADACC === 'Y') >= 0 ? true : false);
        }
        setWriteAcc(write_accs)

    }, [rowdata, ctrlState.data]);




    const onClickviewall = () => {
        if (state.projectData.length > 0) {
            let Ownernames = [];

            let Owner = ctrlState.data;
            Ownernames.push({ Role: "OWNER", Name: Owner.owner_name });


            const selectedUserList = state.selectedUserList.map((data) => { data.isValueChecked = false; return data; });

            setState({
                ...state, hidePermissionGrid: true, hideViewAllBtn: true, addpersonbtn: true, viewall: false, checkedUsers: [],
                hideCheckList: true, hideSearchedCheckList: true, hideMessage: true, input: "", selectedUserList: selectedUserList
            })

        }
    }


    const onClickaddperson = async () => {

        setGrantPermission(true);
        var returnData = {};
        if (state.projectData.length > 0) {
            returnData = await buildGrid(state.projectData);
        }
        setState({ ...state, ...returnData, hideSearchedCheckList: true, hideViewAllBtn: false, addpersonbtn: false, viewall: true, hideMessage: true, isApplyDisabled: true, hideCheckList: false, input: "", checkedUsers: [] })
    }

    const handleChange = (e) => {
        let AllUserslist = state.UserList;
        if (e.target.value !== "") {
            let searchkey = e.target.value.toUpperCase();
            let searchedusers = AllUserslist.filter(o => (o.first_name?.toUpperCase().includes(searchkey) || o.last_name?.toUpperCase().includes(searchkey)) && ctrlState.data.created_by !== o.email_id);
            let distinctusers = [];
            if (searchedusers.length > 0) {
                searchedusers.map((values) => {
                    let existingusers = state.projectData.findIndex(o => o.email_id === values.email_id);
                    if (existingusers < 0) {
                        distinctusers.findIndex(o => o.email_id === values.email_id) && distinctusers.push(values);
                    }
                })
            }
            setState({ ...state, selectedUserList: distinctusers, hideCheckList: false, hideSearchedCheckList: false, input: e.target.value })
        }
        else {
            setState({ ...state, selectedUserList: [], hideSearchedCheckList: true, input: "" })
        }

    }

    const [appAC, setAppAC] = useState(null);
    useEffect(() => {
        if (activeApps.length >= 1) {
            let appFind = activeApps.find((v) => v.app_name === "PRJWSC");
            setAppAC(appFind)
        }
    }, [activeApps])

    const onApply = () => {
        let setPermissions = [];
        // let userList = state.selectedUserList;
        state.checkedUsers.map((eachUser) => {
            // userList.map((eachUser) => {
            // if (eachUser.email_id === userName) {
            var currentdate = new Date();
            setPermissions.push({
                app_id: appAC.app_id, app_description: appAC.app_description, app_name: eachUser.app_name, created_by: profileState.givenName + ' ' + profileState.familyName,
                display_name: eachUser.display_Name, email_id: eachUser.email_id, enabled_flag: "Y", end_date: null,
                first_name: eachUser.first_name, given_name: eachUser.given_name, job_title: eachUser.job_title,
                last_name: eachUser.last_name, mobile_phone: eachUser.mobile_phone, office_location: eachUser.office_location,
                project_id: ctrlState.data.project_id, project_name: ctrlState.data.project_name, project_number: ctrlState.data.project_number,
                read_access: "Y", start_date: getDt(currentdate), surname: eachUser.surname, write_access: "Y",
                assigned_by: profileState.email
            });
            // }
            // })
        })
        dispatch({ type: CREATE_PRJASN, userData: setPermissions });
        setState({ ...state, hideCheckList: true, hideSearchedCheckList: true, hidePermissionGrid: false, checkedUsers: [] })
    }

    const onSelectedNames = (e, user) => {
        let isValueChecked = e.target.checked;
        if (isValueChecked) {
            state.checkedUsers.push(user)
        } else {
            const index = state.checkedUsers.findIndex(s => s.email_id === e.target.id);
            if (index > -1) {
                state.checkedUsers.splice(index, 1)
            }
            // var index = state.checkedUsers.indexOf(e.target.id)
            // if (index > -1) { state.checkedUsers.splice(index, 1) }
        }
        if (state.selectedUserList.length > 0) {
            // const selectedUserList = state.selectedUserList.filter(s => s.email_id === e.target.id)[0];
            // if (selectedUserList) {
            //     selectedUserList.isValueChecked = e.target.checked;
            // }
            setState({ ...state, isApplyDisabled: false, selectedUserList: [...state.selectedUserList] })
        } else {
            setState({ ...state, isApplyDisabled: true })
        }
    }


    const onEditPermissionClick = (e) => {
        //console.log("e.data",e.data)
        let clickedCell = e.colDef.field;
        var rowNode = e.node;
        let read_access = e.data.read_access;
        let write_access = e.data.write_access;
        var updatePermissions = false
        if ((clickedCell === "read_access" || clickedCell === "write_access") && writeAcc) {
            if (clickedCell === "read_access" && write_access !== "Y") {
                read_access = read_access === "Y" ? "N" : "Y";
                updatePermissions = true;
            } else if (clickedCell === "write_access") {
                write_access = write_access === "Y" ? "N" : "Y";
                read_access = write_access === "Y" ? "Y" : read_access;
                updatePermissions = true;
            }

            var newData = { ...e.data, read_access: read_access, write_access: write_access }
            rowNode.setData(newData);
            // console.log("newData",newData)
            // console.log(e.data.start_date,"e.data.start_date")
            if (e.data.project_assign_id && updatePermissions) {
                newData.start_date = getDt(e.data.start_date);
                newData.end_date = getDt(e.data.end_date);
                newData.last_updatedby = profileState.email;
                dispatch(updatePrjAsn(newData))
                //         const end_date = newData.end_date?.split(' ')[0] || '';
                //     const toUser = {
                //         TemplateCode: 'ASSIGN_PROJECT',
                //         Label1: 'Contact_Name',
                //         Value1: `${newData.first_name}`,
                //         Label2: 'Grantor_Name',
                //         Value2: profileState.givenName,
                //         Label3: 'env',
                //         Value3: envInstance.envName,
                //         Label4: 'Last_Name',
                //         Value4: newData.last_name,
                //         Label5: 'Read_Access',
                //         Value5: newData.read_access,
                //         Label6: 'Write_Access',
                //         Value6: newData.write_access,
                //         Label7: 'Start_Date',
                //         Value7: newData.start_date.split(' ')[0],
                //         Label9: 'Assigned_By',
                //         Value9: profileState.givenName,
                //         Label10: 'Project_Name',
                //         Value10: newData.project_name,
                //         toMailAddress:newData.email_id,
                //         ccMailAddress: profileState.email,
                //         bccMailAddress: '',
                //         Subject: '',
                //         Body: '',
                //         Signature: '',
                //         Attachment: [{
                //             contentType: '',
                //             filecontent: '',
                //             filename: '',
                //         }],
                //     };
                //     if (end_date) {
                //         toUser.Label8 = 'End_Date';
                //         toUser.Value8 = end_date;
                //     }

                //    dispatch(sendMailStart(toUser));

            } else {
                const updatedUserData = []
                userData.map((data) => {
                    if (data.email_id === newData.email_id) {
                        updatedUserData.push(newData)
                    } else {
                        updatedUserData.push(data)
                    }
                });
                dispatch({ type: CREATE_PRJASN, userData: [...updatedUserData] })
            }
        }
    }
    let notinwPL = JSON.parse(JSON.stringify(notiPL));


    const onAssignPermission = async () => {
        dispatch(showLoader(true));
        const selectedUsers = [];
        const promises = userData.map(async (data) => {
            selectedUsers.push(data.first_name + " " + data.last_name);
            data.created_by = profileState.email;
            data.display_name = data.first_name + " " + data.last_name;
            console.log(data, "data")
            await dispatch(createPrjAsn(data));
            const end_date = data.end_date?.split(' ')[0] || '';
            const toUser = {
                TemplateCode: 'ASSIGN_PROJECT',
                Label1: 'Contact_Name',
                Value1: `${data.first_name}`,
                Label2: 'Grantor_Name',
                Value2: profileState.givenName,
                Label3: 'env',
                Value3: config.ENV,
                Label4: 'Last_Name',
                Value4: data.last_name,
                Label5: 'Read_Access',
                Value5: data.read_access,
                Label6: 'Write_Access',
                Value6: data.write_access,
                Label7: 'Start_Date',
                Value7: data.start_date.split(' ')[0],
                Label9: 'Assigned_By',
                Value9: profileState.givenName,
                Label10: 'Project_Name',
                Value10: data.project_name,
                toMailAddress: data.email_id,
                ccMailAddress: profileState.email,
                bccMailAddress: '',
                Subject: '',
                Body: '',
                Signature: '',
                Attachment: [{
                    contentType: '',
                    filecontent: '',
                    filename: '',
                }],
            };
            if (end_date) {
                toUser.Label8 = 'End_Date';
                toUser.Value8 = end_date;
            }

            await dispatch(sendMailStart(toUser));
        });


        await Promise.all(promises);


        let userName = '';
        if (selectedUsers.length === 1) {
            userName = selectedUsers[0];
        } else if (selectedUsers.length === 2) {
            userName = selectedUsers.join(" and ");
        } else {
            userName = selectedUsers.join(", ");
        }


        // const selectedUserList = state.selectedUserList.map((data) => { data.isValueChecked = false; return data; });
        setState({ ...state, hideMessage: false, hidePermissionGrid: true, addpersonbtn: true, assignedUsers: userName });

        dispatch(showLoader(false));
    };

    const navHome = () => {
        dispatch(hidePkgsAct());
        // history.push("/");
        navigate('/')
    }


    const navProjInfo = () => {
        ctrlState.updProj = true;
        ctrlState.due_date = new Date(ctrlState.due_date)
        ctrlState.last_mod_date = new Date(ctrlState.last_mod_date)
        dispatch(showUpdProj(ctrlState))
    }

    let UsersCount = state.projectData.length;
    return (
        <>
            <Loader />


            <AppBar className="headerMain" id="tagsNavbar">

                <Grid container className="marginRow" spacing={1.4}>
                    <Grid item md={6} sm={6} xs={6}>

                        <h6 className="fntColor" style={{ marginTop: '0px' }}>{(ctrlState.data.project_name?.length > 30 ? ctrlState.data.project_name.substr(0, 29) + '...' : ctrlState.data.project_name) + ' - ' + (ctrlState.data.project_number?.length > 30 ? ctrlState.data.project_number.substr(0, 29) + '...' : ctrlState.data.project_number)}</h6>
                        <DynamicBreadcrumbs onHome={navHome} onPackages={() => navigate('/pkgs')} />


                    </Grid>

                    <Grid item md={6} sm={6} xs={6}>


                        <div className='d-flex'>
                            <div className="ml-auto rt-actions d-flex">
                                <div>
                                    <SettingsMenu />
                                </div>
                            </div>
                        </div>

                    </Grid>
                </Grid>

            </AppBar>


            <Container className="container-fluid container-left-space" maxWidth="xl">
                {/* <Row className="mb-2 mt-2">
                    <Col md={12} lg={12}>
                        <span style={{ fontSize: "1.0rem", fontColor: "#E6E6E6" }}>Project Name</span>
                        <Row>
                            <h5>{ctrlState.data.project_name + ' - ' + ctrlState.data.project_number}</h5>
                        </Row>
                    </Col>
                </Row> */}
                <Grid container className="mb-2 mt-3">
                    <Grid item md={2}>
                        <div>

                            {state.Ownerslist.map((item, i) => {

                                return <div className='mb-3' key={i}>
                                    <div className="px-2 py-2" style={{ backgroundColor: "#fff", border: "1px solid #E6E6E6" }}>
                                        <h6 className='mb-0 font-bold'>{item.Role}</h6>
                                    </div>
                                    <div className="px-1 py-2 media" style={{ backgroundColor: "#E6E6E6" }}>
                                        <div style={{ alignItems: "center", display: "flex", marginRight: "0.2rem" }}>
                                            <img className="d-inline-block align-self-center mr-3" src={userLogo} width="40" height="40" alt="user-logo" />
                                        </div>
                                        <div className="media-body">
                                            <p style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                                                {item.Name}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            })
                            }
                        </div>
                        <div style={{ paddingTop: '10px' }} >
                            <BtnC outline={true} hidden={state.hideViewAllBtn} color='success' className='mr-2 text-center view-all-btn btn btn-outline-success b-1' onClick={() => onClickviewall()} label={`${t('View All')} (${UsersCount})`} />
                        </div>

                        <div className="mt-2">

                            <BtnC outline={false} hidden={!state.addpersonbtn} color='success' disabled={!writeAcc} className='mr-2 mr-2 text-center add-person-btn btn btn-success' onClick={() => { if (writeAcc) { onClickaddperson() } }} label={t('Add a Person')} />
                            {/* <BtnC outline={false} hidden={!state.addpersonbtn} color='success' disabled={wrt_accs=='Y'? false :true} className='mr-2 mr-2 text-center add-person-btn btn btn-success' onClick={()=>{if(wrt_accs=='Y'){onClickaddperson() }}} label='Add a Person' /> */}
                        </div>
                    </Grid>
                    <Grid md={10} style={{ paddingLeft: '24px' }} >
                        <Grid>
                            <div hidden={state.hideCheckList}>
                                <span style={{ fontSize: '14px' }}> {t('Wish to grant Permission')}  ? </span>
                            </div>
                        </Grid>
                        <Grid>
                            <div hidden={state.hideCheckList}>
                                <div id="searchPermission" className="input-group" style={{ width: 500 }}>
                                    <input className="form-control font-13" value={state.input}
                                        style={{ width: 500 }}
                                        disabled={!writeAcc}
                                        placeholder={t('Enter Name')}
                                        aria-describedby="text-search"
                                        onChange={(e) => { if (writeAcc) handleChange(e) }}  ></input>
                                    {/* <input className="form-control font-13" value={state.input} style={{ width: 500 }} disabled={wrt_accs=='Y'? false :true} placeholder="Enter Name" aria-describedby="text-search" onChange={(e) =>{if(wrt_accs=='Y') handleChange(e) }}  ></input> */}
                                </div>
                                <div hidden={state.hideSearchedCheckList}>
                                    <Card style={{ width: 500 }} className="list-of-user">
                                        <CardContent style={{ width: 500, maxHeight: '200px', overflowY: 'scroll' }}>
                                            {state.selectedUserList.map((user, i) => {
                                                const isValueChecked = state.checkedUsers.findIndex(s => s.email_id === user.email_id) > -1 ? true : false;
                                                return (<FormGroup id={i} check key={i}>
                                                    <div style={{ paddingBottom: '0px' }} className="custom-checkbox">
                                                        <FormControlLabel className="form-check" control={<Checkbox onChange={(e) => onSelectedNames(e, user)} id={user.email_id} checked={isValueChecked} />} label={<span> {user.first_name} {user.last_name} <br /> {user.email_id}</span>} />
                                                        {/* <Input type="checkbox"  name="check"   /> */}
                                                        {/* <Label for={user.email_id} check></Label> */}
                                                    </div>
                                                </FormGroup>
                                                )
                                            })
                                            }
                                        </CardContent>
                                        <div style={{ display: "flex", justifyContent: "center", padding: '10px' }}>
                                            <BtnC outline={false} disabled={state.checkedUsers.length > 0 ? false : true} hidden={state.addpersonbtn} color='success' className='mr-2 text-center sbtn btn btn-secondary text-white' onClick={() => onApply()} label={t('Apply')} />
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </Grid>
                        <div hidden={state.hidePermissionGrid} id="permissiongrid" className="ag-theme-alpine" style={{ marginTop: 0, height: '66vh' }}>
                            <AgGridReact
                                statusBar={statusBar}
                                groupHeaderHeight={35}
                                headerHeight={30}
                                rowData={userData}
                                localeText={agGridTrans[localStorage.getItem("lang")]}
                                // immutableData={true}
                                components={{ DateRenderer: PermissionDates }}
                                // frameworkComponents={{ DateRenderer: PermissionDates }}
                                columnDefs={[
                                    {
                                        "headerName": t('ASSIGN PERMISSION'),
                                        "children": [
                                            { headerName: t('First Name'), field: 'first_name', width: 180, filter: true, resizable: true },
                                            { headerName: t('Last Name'), field: 'last_name', width: 180, filter: true, resizable: true },
                                            {
                                                headerName: t('Read Access'), field: 'read_access', width: 130, filter: true, resizable: true,
                                                cellRenderer: function (permission) {
                                                    if (permission.data.read_access === "N") {
                                                        {/*return <i className="fa fa-circle" style={{ cursor: "pointer" }}></i>*/ }
                                                        return <BsCircle style={{ cursor: "pointer", marginLeft: '5%' }} />
                                                    } else {
                                                        {/*return <i className="fa fa-check" style={{ color: "#00aa7e" }}></i>*/ }
                                                        return <TiTick style={{ color: COLORS.green, fontSize: '22px', cursor: "pointer" }} />
                                                    }
                                                }
                                            },
                                            {
                                                headerName: t('Write Access'), field: 'write_access', width: 180, filter: true, resizable: false,
                                                cellRenderer: function (permission) {
                                                    if (permission.data.write_access === "N") {
                                                        {/*return <i className="fa fa-circle" style={{ cursor: "pointer" }}></i>*/ }
                                                        return <BsCircle style={{ cursor: "pointer", marginLeft: '5%' }} />
                                                    } else {
                                                        {/*return <i className="fa fa-check" style={{ color: "#00aa7e" }}></i>*/ }
                                                        return <TiTick style={{ color: COLORS.green, fontSize: '22px', cursor: "pointer" }} />
                                                    }
                                                }
                                            },
                                            // {
                                            //     headerName: 'Role/Access', field: 'read_access', width: 130, editable: false,
                                            //     cellRenderer: 'PermissionSelectRenderer', filter: true
                                            // },
                                            {
                                                headerName: t('Start Date'), field: 'start_date', width: 180, editable: false,
                                                cellRenderer: 'DateRenderer', filter: true, cellStyle: { padding: 0 }
                                            },
                                            {
                                                headerName: t('End Date'), field: 'end_date', width: 180, editable: true,
                                                cellRenderer: 'DateRenderer', editable: false, filter: true, cellStyle: { padding: 0 }
                                            },
                                            { headerName: t('Assigned By'), field: 'assigned_by', width: 250, filter: true, resizable: true },
                                        ]
                                    }]}
                                rowHeight={28}
                                defaultColDef={{ menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'] }}
                                // getRowNodeId={(data, i) => i}
                                getRowId={(data, i) => data.data.email_id}
                                onCellDoubleClicked={(rec) => onEditPermissionClick(rec)}
                                gridOptions={{ popupParent: document.querySelector('body') }}
                                onGridReady={onGridReady}
                                rowSelection={"multiple"}
                                enableRangeSelection={true}
                                suppressCopyRowsToClipboard={true}
                            />
                        </div>
                        <div className={`d-flex justify-content-end ${!state.hidePermissionGrid && "mt-3"}`} hidden={state.hidePermissionGrid}>
                            <BtnC outline={false} hidden={state.hidePermissionGrid} color='success' className='mr-2 text-center sbtn btn btn-secondary text-white' onClick={() => onAssignPermission()} label={t('Assign')} />
                        </div>
                        <div hidden={state.viewall} id="permissiongrid1" className="ag-theme-alpine ag-date-picker">
                            <AgGridReact
                                statusBar={statusBar}
                                groupHeaderHeight={35}
                                headerHeight={30}
                                rowData={state.projectData}
                                localeText={agGridTrans[localStorage.getItem("lang")]}
                                // immutableData={true}
                                components={{ DateRenderer: PermissionDates }}
                                // frameworkComponents={{ DateRenderer: PermissionDates }}
                                columnDefs={[
                                    { headerName: t('First Name'), field: 'first_name', width: 190, filter: true, resizable: true, minWidth: 150 },
                                    { headerName: t('Last Name'), field: 'last_name', width: 190, filter: true, resizable: true, minWidth: 150 },
                                    {
                                        headerName: t('Read Access'), field: 'read_access', width: 115, filter: true, resizable: true, minWidth: 150,
                                        cellRenderer: function (permission) {
                                            if (permission.data.read_access === "N") {
                                                {/*return <i className="fa fa-circle" style={{ cursor: "pointer" }}></i>*/ }
                                                return <BsCircle style={{ cursor: "pointer", marginLeft: '5%' }} />
                                            } else {
                                                {/*return <i className="fa fa-check" style={{ color: "#00aa7e" }}></i>*/ }
                                                return <TiTick style={{ color: COLORS.green, fontSize: '22px', cursor: "pointer" }} />
                                            }
                                        }
                                    },
                                    {
                                        headerName: t('Write Access'), field: 'write_access', width: 115, filter: true, resizable: false, minWidth: 150,
                                        cellRenderer: function (permission) {
                                            if (permission.data.write_access === "N") {
                                                {/*return <i className="fa fa-circle" style={{ cursor: "pointer" }}></i>*/ }
                                                return <BsCircle style={{ cursor: "pointer", marginLeft: '5%' }} />
                                            } else {
                                                {/*return <i className="fa fa-check" style={{ color: "#00aa7e" }}></i>*/ }
                                                return <TiTick style={{ color: COLORS.green, fontSize: '22px', cursor: "pointer" }} />
                                            }
                                        }
                                    },
                                    // {
                                    //     headerName: 'Role/Access', field: 'read_access', width: 130, resizable: true, minWidth: 100, editable: false,
                                    //     cellRenderer: 'PermissionSelectRenderer', filter: true
                                    // },
                                    {
                                        headerName: t('Start Date'), field: 'start_date', width: 166, resizable: true, minWidth: 100, editable: false,
                                        cellRenderer: 'DateRenderer', filter: true, cellStyle: { padding: 0 }
                                    },
                                    {
                                        headerName: t('End Date'), field: 'end_date', width: 166, resizable: true, minWidth: 100, editable: false,
                                        cellRenderer: 'DateRenderer', cellRendererParams: { writeAcc: writeAcc }, filter: true, cellStyle: { padding: 0 }
                                    },
                                    { headerName: t('Assigned By'), field: 'created_by', width: 260, filter: true, resizable: false, minWidth: 150 },
                                ]}
                                rowHeight={28}
                                // getRowNodeId={data => data.project_assign_id}
                                getRowId={data => data.data.project_assign_id}
                                onCellDoubleClicked={(rec) => onEditPermissionClick(rec)}
                                gridOptions={{ popupParent: document.querySelector('root') }}
                                onGridReady={onGridReady}
                                rowSelection={"multiple"}
                                enableRangeSelection={true}
                                alwaysShowVerticalScroll={true}
                                alwaysShowHorizontalScroll={true}
                                suppressCopyRowsToClipboard={true}
                            />
                        </div>
                        <div hidden={state.hideMessage} style={{ backgroundColor: "#E6E6E6" }}>
                            <Card>
                                <CardContent>
                                    <div className="d-flex justify-content-center">
                                        <img src={Successfull} width="40" height="40" />
                                        <h5 className="mt-2" style={{ color: COLORS.green, paddingLeft: '10px' }}>{t('SUCCESSFULL')}</h5>
                                    </div>
                                    <h6 style={{ textAlign: 'center' }}>{state.assignedUsers} {t('added Successfully!')}</h6>
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>
                </Grid>
                <UpdateProject isDisabled={true} />
            </Container>
        </>
    )
}

export default Permissions;